
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import _Link from 'next/link'
import { Heading as _Heading } from '@/components/Heading'
import { DocumentationLayout as _Layout } from '@/layouts/DocumentationLayout'
import { ContentsLayout as _Default } from '@/layouts/ContentsLayout'
const Layout = _Layout;
const meta = {
  "id": "firebase",
  "title": "Firebase",
  "sidebar_label": "Firebase"
};
const slug = 'firebase';
const tableOfContents = [{
  "title": "Introduction",
  "slug": "introduction",
  "children": [{
    "title": "Video: Configuring Firebase",
    "slug": "video-configuring-firebase",
    "children": []
  }]
}, {
  "title": "Step by Step",
  "slug": "step-by-step",
  "children": []
}, {
  "title": "Downloading Android JSON",
  "slug": "downloading-android-json",
  "children": []
}, {
  "title": "Applying Firebase Rules",
  "slug": "applying-firebase-rules",
  "children": []
}];

const layoutProps = {
  Layout,
meta,
slug,
tableOfContents
};
const MDXLayout = _Default
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">






    <h1>{`Integrating Firebase for Mobile App Chats and Push Notifications`}</h1>
    <p>{`Not applicable for web templates if there is no chats `}</p>
    <_Heading level={2} id={"introduction"} nextElement={{
      "type": "paragraph"
    }}>Introduction</_Heading>
    <p>{`Firebase which is owned by Google provide multiple set of features more specifically focused on Mobile app and gradually bringing new features for web apps as well.
Having a glance the URL : `}<a parentName="p" {...{
        "href": "https://firebase.google.com/"
      }}>{`https://firebase.google.com/`}</a>{` can tell you every list of features they offer. Apart from confidential notes, we use firebase to allow you to `}</p>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Check your app stability and Performance using their Crashlytics`}</li>
      <li parentName="ul">{`We use App Distribution to share pre-release built with you, so you can share with your team to test the app before it get’s published`}</li>
      <li parentName="ul">{`It does bring you out of box features like Dynamic Links, Predictions, Cloud Messaging, etc.`}</li>
    </ul>
    <p>{`Firebase done a good job of explaining each features through a short video on every page you navigate, so you will be educated if this is the first time you are using Firebase.`}</p>
    <_Heading level={3} id={"video-configuring-firebase"} nextElement={{
      "type": "paragraph"
    }}>Video: Configuring Firebase</_Heading>
    <p>{`See how to configure stripe for your marketplace. `}</p>
    <div class="aspect-w-16 aspect-h-9">
      <iframe width="100%" height="100%" src="https://www.youtube.com/embed/ZyXP4BoVZr4" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </div>
    <_Heading level={2} id={"step-by-step"} nextElement={{
      "type": "list",
      "ordered": true,
      "start": 1,
      "spread": false
    }}>Step by Step</_Heading>
    <ol {...{
      "role": "list"
    }}>
      <li parentName="ol">{`Go to `}<a parentName="li" {...{
          "href": "https://firebase.google.com/?utm_source=tradly-platform&utm_campaign=portal&utm_medium=portal"
        }}>{`Firebase`}</a>{` `}</li>
      <li parentName="ol">{`Signup for a free account using your gmail account (It is recommended to have one GmailID or GoogleApps email for all your signup like this)`}</li>
      <li parentName="ol">{`Create a new project as you see here `}<img parentName="li" {...{
          "src": "/img/fb-newproject.png",
          "alt": "fb-newproject"
        }}></img></li>
      <li parentName="ol">{`Name your project `}<img parentName="li" {...{
          "src": "/img/fb-nameit.png",
          "alt": "fb-nameit"
        }}></img></li>
      <li parentName="ol">{`As Google analytics comes on top of firebase and it’s free. Consider enabling to get free mobile app analytics `}<img parentName="li" {...{
          "src": "/img/fb-enablega.png",
          "alt": "fb-enablega"
        }}></img></li>
      <li parentName="ol">{`You will not find anything like ist… but you need to create your Google cloud solution account as well  `}<img parentName="li" {...{
          "src": "/img/fb-addgcp.png",
          "alt": "fb-addgcp"
        }}></img></li>
      <li parentName="ol">{`From here you can go to upgrade your billing option as Blaze plan is necessary `}<img parentName="li" {...{
          "src": "/img/fb-upgrade.png",
          "alt": "fb-upgrade"
        }}></img></li>
      <li parentName="ol">{`Choose Blaze plan which is pay as you go plan `}<img parentName="li" {...{
          "src": "/img/fb-blaze.png",
          "alt": "fb-blaze"
        }}></img></li>
      <li parentName="ol">{`From here you can find the access control `}<img parentName="li" {...{
          "src": "/img/fb-users.png",
          "alt": "fb-users"
        }}></img></li>
      <li parentName="ol">{`Add TradlyTeam email sent to you as owner `}<img parentName="li" {...{
          "src": "/img/fb-owner.png",
          "alt": "fb-owner"
        }}></img></li>
    </ol>
    <p>{`Note: Blaze plan is mandatory to deploy push notification for chat messages`}</p>
    <_Heading level={2} id={"downloading-android-json"} nextElement={{
      "type": "paragraph"
    }}>Downloading Android JSON</_Heading>
    <p>{`Downloading Android Plist Json from Firebase. Visit Project Settings > General > Find the JSON file in the body section. See the blue button as per the below screenshots. `}</p>
    <img src="/img/firebase-json1.png" alt="Downloading Android Plist Json from Firebase" width="400" />
    <img src="/img/firebase-json2.png" alt="Downloading Android Plist Json from Firebase" width="400" />
    <img src="/img/firebase-json3.png" alt="Downloading Android Plist Json from Firebase" width="400" />
    <_Heading level={2} id={"applying-firebase-rules"} nextElement={{
      "type": "paragraph"
    }}>Applying Firebase Rules</_Heading>
    <p>{`Read below on how to create Realtime Database and apply realtime database rules.`}</p>
    <ol {...{
      "role": "list"
    }}>
      <li parentName="ol">
        <p parentName="li">{`Navigate to your firebase project on the Firebase console and select Realtime Database under Build section from left menu.`}</p>
        <img src="/img/firebase-rules1.png" alt="Setting up firebase rules" width="400" />
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click “Create Database”`}</p>
        <img src="/img/firebase-rules2.png" alt="Setting up firebase rules" width="600" />
      </li>
      <li parentName="ol">
        <p parentName="li">{`Select desired storage location which is close to your country and click ‘Next’.`}</p>
        <img src="/img/firebase-rules3.png" alt="Setting up firebase rules" width="600" />
      </li>
      <li parentName="ol">
        <p parentName="li">{`Leave it in Locked Mode, click Enable.`}</p>
        <img src="/img/firebase-rules4.png" alt="Setting up firebase rules" width="600" />
      </li>
      <li parentName="ol">
        <p parentName="li">{`Great! You have created Realtime Database successfully. Now let’s apply database rules. Select Rules tab and copy-paste below given rules and click Publish`}</p>
      </li>
    </ol>
    <pre><code parentName="pre" {...{}}>{`{
  "rules": {
  "$env":{
      "users":{
         "$uid": 
         { 
           ".read": "auth != null"
         },
         ".write":"auth != null"       
  },
  "chats":{
   "$chatroom_id":{
    ".read":"auth != null && root.child($env+'/chats/'+$chatroom_id+'/users/'+auth.uid).exists()",
    ".write": "auth != null"
   }
  }
   }
}
}
`}</code></pre>
    <img src="/img/firebase-rules5.png" alt="Setting up firebase rules" width="800" />



    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
MDXContent.layoutProps = layoutProps
